import {
  CLIENT_API_PHOTO_GALLERY_DETAIL_KEY,
  CLIENT_API_PHOTO_GALLERY_KEY,
  CLIENT_API_PHOTO_GALLERY_URL,
  CLIENT_API_VIDEO_GALLERY_DETAIL_KEY,
  CLIENT_API_VIDEO_GALLERY_KEY,
  CLIENT_API_VIDEO_GALLERY_URL,
} from '~/shared/api/client/galleries/galleries.const';
import {
  EVENT_MEDIA_MODES,
  EVENTS_GALLERY_DETAIL_ROUTE_NAMES,
  EVENTS_ROUTE_NAMES,
  type EventMediaMode,
} from '~/shared/lib/events-routes.const';

export const EVENTS_GALLERY_DETAIL_CONFIG: Record<
  EventMediaMode,
  {
    apiUrl: string;
    detailKey: string;
    relatedKey: string;
    listRouteName: string;
    detailRouteName: string;
    breadcrumbLabel: string;
    fallbackTitle: string;
    notFoundText: string;
    emptyText: string;
  }
> = {
  [EVENT_MEDIA_MODES.photos]: {
    apiUrl: CLIENT_API_PHOTO_GALLERY_URL,
    detailKey: CLIENT_API_PHOTO_GALLERY_DETAIL_KEY,
    relatedKey: CLIENT_API_PHOTO_GALLERY_KEY,
    listRouteName: EVENTS_ROUTE_NAMES.photos,
    detailRouteName: EVENTS_GALLERY_DETAIL_ROUTE_NAMES.photos,
    breadcrumbLabel: 'Фотоотчеты',
    fallbackTitle: 'Фотоотчет',
    notFoundText: 'Фотоотчет не найден',
    emptyText: 'В этой галерее пока нет фото',
  },
  [EVENT_MEDIA_MODES.videos]: {
    apiUrl: CLIENT_API_VIDEO_GALLERY_URL,
    detailKey: CLIENT_API_VIDEO_GALLERY_DETAIL_KEY,
    relatedKey: CLIENT_API_VIDEO_GALLERY_KEY,
    listRouteName: EVENTS_ROUTE_NAMES.videos,
    detailRouteName: EVENTS_GALLERY_DETAIL_ROUTE_NAMES.videos,
    breadcrumbLabel: 'Видеоотчеты',
    fallbackTitle: 'Видеоотчет',
    notFoundText: 'Видеоотчет не найден',
    emptyText: 'В этой галерее пока нет видео',
  },
};
